import type { Program, ProgramWithingsOrderPostContentObjectList } from 'models';

import { Modal, message } from 'ui';

import { WithingsOrderPostForm, type WithingsOrderPostSubmitData } from './components';
import { useUpdateWithingsOrderPostMutation } from './queries';

type P = {
  isOpened: boolean;
  objectData: ProgramWithingsOrderPostContentObjectList;
  onCancel: () => void;
  onRequestReturn?: () => void;
  onSuccess: () => Promise<void> | void;
  program: Program;
};

const EditWithingsOrderPost = ({ isOpened, objectData, onCancel, onRequestReturn, onSuccess, program }: P) => {
  const { isPending, mutate } = useUpdateWithingsOrderPostMutation();

  const onSubmit = (data: WithingsOrderPostSubmitData) => {
    mutate(
      {
        ...data,
        programId: program.id,
        withingsPostOrderId: objectData.withings_order_post.id,
      },
      {
        onError() {
          message.error('Something went wrong, please try again later.');
        },
        async onSuccess() {
          await onSuccess();
          message.success('Order was updated.');
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Edit Order" width="medium">
      <Modal.HugContent>
        <WithingsOrderPostForm
          loading={isPending}
          objectData={objectData}
          onRequestReturn={onRequestReturn}
          onSubmit={onSubmit}
          program={program}
          submitText="Edit Post"
        />
      </Modal.HugContent>
    </Modal>
  );
};

export default EditWithingsOrderPost;
